import CursorInspector from "@features/builder/graph/devtools/CursorInspector"
import css from "./graphDevtools.module.css"

import NodeInspector from "@features/builder/graph/devtools/NodeInspector"

export default function ReactFlowDevTools() {
  return (
    <div className={css.reactFlowDevtools}>
      {import.meta.env.VITE_SHOW_DEBUG_NODES === "true" && <NodeInspector />}
      {import.meta.env.VITE_SHOW_DEBUG_CURSOR === "true" && <CursorInspector />}
    </div>
  )
}
